import axios from 'axios';
import config from 'config/config';
import { LanSettings } from 'types/common';

class TableService {
    host = config.API_BASE_URL;
    apiPath = '/v1/settings';

    async getSettings(): Promise<LanSettings> {
        return axios.get(`${this.host}${this.apiPath}`).then(res => res.data.data);
    }

}

export default new TableService();
